import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PushNotificationService } from './_utils/push-notification/push-notification.service';
import { StorageService } from './_utils/storage/storage.service';
import { LAST_ACCESS_NAME, UPDATE_APP_TIME } from './app.config';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { PwaService } from './_utils/pwa/pwa.service';
import { ManifestService } from './manifest.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styles: [],
})
export class AppComponent {
  public PWA_VERSION: string = '';
  swBroadcastChannel;

  constructor(
    private pwaService: PwaService,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    private pushNotificationService: PushNotificationService,
    private storageService: StorageService,
    private manifestService: ManifestService
  ) {
    this.pushNotificationService.onTokenChanges(); // check for token changes
    this.pwaService.checkForUpdate(); // check for pwa updates

    // this broadcast channel is used to receive notifications from the service worker
    this.swBroadcastChannel = new BroadcastChannel('fcm-sw-broadcastChannel');
    this.swBroadcastChannel.onmessage = (message) => {
      console.log('message received from service worker', message);
      if (
        message.data &&
        message.data.action === 'redirect-from-notificationclick'
      ) {
        console.log('Redirect from notification to ' + message.data.url);
        router.navigate([message.data.url], { queryParams: { reload: true } });
      }
    };
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    // Save last access date to storage when the user leaves the app
    // this is used to check if (in the next session) if there is new
    // offers available
    this.storageService.saveValue(LAST_ACCESS_NAME, Date.now());
  }
}
